module.exports = __webpack_public_path__ + "img/ltkbuynow-4x.074e1e7.jpg";